<template lang="html">
<v-layout column>
  <toolbar :title="`Load Group Details: ${_.get(loadGroup, 'humanId', 'loading ...')}`">
        <v-icon @click="loadListing()">refresh</v-icon>
  </toolbar>
  <v-planning-tool v-if="loadGroup && ownerCompany"
                   :company="ownerCompany"
                   :selectedLoad="loadGroup">

  </v-planning-tool>
</v-layout>
</template>

<script>
import _ from 'lodash';
import API from '@/api';
import Toolbar from '@/components/Toolbar';
import VPlanningTool from '@/pages/Companies/Loads/components/PlanningTool';

import { mapState, mapGetters } from 'vuex';
import * as types from '@/store/mutationTypes';
import refreshPageMixin from '@/mixins/refreshPageMixin';

export default {
  name: 'ListingDetail',
  mixins: [
    refreshPageMixin,
  ],
  data: () => ({
    loadGroup: null,
    loadedOwnerCompany: null,
  }),
  computed: {
    ...mapState('applications', [
      'currentUser',
    ]),
    ...mapGetters('companies', [
      'companiesWithOptions',
    ]),
    _() {
      return _;
    },
    loadGroupId() {
      return this.$route.params.id;
    },
    ownerCompany() {
      return this.loadedOwnerCompany || _.get(this.loadGroup, 'loadGroup.details.listingCompany');
    },
  },
  components: {
    VPlanningTool,
    Toolbar,
  },
  created() {
    this.$ga.event({
      eventCategory: 'open_section',
      eventAction: 'listing_detail',
      eventLabel: this.loadGroupId,
    });
    this.loadListing();
  },
  methods: {
    onRefresh() {
      this.loadListing();
    },
    async loadListing() {
      try {
        this.$store.commit(`applications/${types.START_LOADING}`);
        const response = await API.planner.getLoad( this.loadGroupId );
        this.loadGroup = response.data;

        const ownerId = this.loadGroup.loadGroup.details.listingCompany.id;
        API.company.byId({ id: ownerId })
          .then((response) => this.loadedOwnerCompany = response.data);

      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', { message: error.message });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
  },
};
</script>

<style>
  .id-col-header {
    padding-left: 35px !important;
  }

  .id-col {
    position: relative;
    padding-left: 35px !important;
  }

  .expand-icon-details {
    position: absolute;
    left: 5px;
    top: 10px;;
    bottom: auto;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Listings/Detail.vue